/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-wrapper[_ngcontent-%COMP%]{display:block;position:-webkit-sticky;position:sticky;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,.9);z-index:100000}.spinner-wrapper[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{position:absolute;left:50%;margin-left:-30px;top:50%;margin-top:-30px}mat-select[_ngcontent-%COMP%]{border:1px solid #dde2ec;padding:5px 10px;border-radius:4px}"];
export { styles as styles };
